module.exports = __webpack_public_path__ + "static/media/flexline_hd_logo_no.9372d91d.png";